// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const PairingIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path stroke="currentColor" strokeWidth={1.5} d="M6 9h11v6H6z" />
    <rect
      width={4}
      height={10}
      x={2}
      y={7}
      stroke="currentColor"
      strokeWidth={1.5}
      rx={1}
    />
    <rect
      width={4}
      height={10}
      x={17}
      y={7}
      stroke="currentColor"
      strokeWidth={1.5}
      rx={1}
    />
  </svg>,
  "Pairing",
);
export default PairingIcon;
